var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.62793,
    y: 0.383789,
    width: 11.7442,
    height: 11.9767,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1076_4678",
    transform: "translate(0 0.0097087) scale(0.01 0.00980583)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1076_4678",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADN0lEQVR4nO3dv2sUQRjG8e8bgk3EIIiFpNTzB2JjkxRa2aTRWEQiYiFipTb6BwiKnU1Q8A8QLUyh2CZNUDCFhURFRa3UFFYaDEJC8lrcRfY2lzN3mcnO7T0fSDF7t+8M93CzP26ZgIiIiIiIiIiIiEgbrNmL7n4IOAVUgL4tGVGaloA5YAqYNLOVWB01DMTd+4H7wNh67+lib4ELZvYqRvE1H3YtjBfA4RgdlsQfYNjMpkMXbhTII+Bs6I5K6AdQMbNfIYv2ZBu1Y8ZYyA5KbDdwNXTRnlx7BB0zWnE6dMF8IPtCd1ByldAF84F086ltO7aHLpgPRAqmQBJTdwB39yFgoKCxdCQzmyh6DCLdQ9cckbj7ADCU2bQAfDSzLwUNqbu5+6g3NuvuI0WPr+s0CWTVnUb76bS3ONfd/XJ+owIp1m1335ndoECK1U/uBqUCKd7RbKM323D3a8Dglg6nw5nZmU2W2JVt9OZeHARGN9mBtKbuWlBTVmLy3xAJ5yuwkRuPM9mGAonEzGaAlo8vmrISo0ASo0ASo0ASo0ASo0ASo0ASo0ASowvDSBr8pr6eb2b2crWhQOIZAh5v4H0TwL9ANGUlRoEkRoEkRoEkRoEkRoEkRoEkRoEkRoEkRoEkRoEkRoEkRoEkRoEkRoEkJh/IUiGj6FyLoQvmA5kL3UHJfQ9dMB/IVOgOSi7455UPZBJ4HbqTkloGxkMXrQukttrmJaprCkpzN83sXeiia86yaqttDlNdU1DWWgZuALdiFG/41ImZTbt7heqagiPAfiIs1tVBFqkewKeA8RjfDInM3S/+ZyWHVXWPCunCMJ697eykQCJw9x6qU33LFEgc54AD7eyoQAJz9yPAvXb3VyCBuHuPu58HngM72q0T/GFrd++2lSD6gIPASdqcprJiPP2+kSe+ZR2ashKjQBITI5DfEWqW2Xy2ESOQTxFqltnnbCNGIE8i1CyrFeBpdkOMQO6iW/cb9dDMPmQ3BA/EzH5SXZZIP3I1NwtcyW+McpZV++9lx4E3Mep3uBXgAXDMzObzL0Zd+7121/NE7W8PsC1mf4lbAN4Dz/LTlIiIiIiIiIiIiMim/QVHZvGNZ18D8wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardServices);
export default __webpack_public_path__ + "static/media/card-services.570d77d6b50e831ce54cba482c27ad59.svg";
export { ForwardRef as ReactComponent };